<template>
    <div v-if="loaded" class="container white-page-container d-flex align-items-center justify-content-center">
        <div v-if="!success && code === 'NO_PAYMENT'">
            <h4 class="text-center mt-6 information-text">Pas de paiement en attente.</h4>
        </div>
        <div v-if="!success && code === 'NO_IDOP'">
            <h4 class="text-center mt-6 information-text">Echec d'accès au paiement, merci de réessayer ultérieurement.</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "RedirectPayfipPayment",
    data() {
        return {
            cadhAnswerId: null,
            payfipUrl: null,
            code: null,
            success: false,
            loaded: true,
        }
    },
    methods: {
        redirectToPayfipPayment() {
            let payload = {
                cadhAnswerId: this.cadhAnswerId,
                urlCl: process.env.VUE_APP_PAYFIP_URLCL
            }

            this.$http.post("redirect-to-payfip", payload).then((response) => {
                if(response.body.success) {
                    window.location.replace(response.body.data.url)
                } else {
                    this.code = response.body.code
                    this.loaded = true
                }
            })
        }
    },
    created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        this.cadhAnswerId = atob(this.$route.params.cadhAnswerId)

        this.redirectToPayfipPayment()
    },
}
</script>